export const QUERY_PARAMS = {
  TRACK_EVENTS: 'trackEvents'
};